// src/styles/GlobalStyles.ts

import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Reset some default styles */
  *, *::before, *::after {
    box-sizing: border-box;
  }

  /* Apply global styles */
  body {
    margin: 0;
    padding: 0;
    background-color: ${({ theme }) => theme.background};
    color: ${({ theme }) => theme.text};
    font-family: 'Arial', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Remove default margin and padding from headings and paragraphs */
  h1, h2, h3, h4, h5, h6, p {
    margin: 0;
    padding: 0;
  }

  /* Links */
  a {
    color: ${({ theme }) => theme.accentColor};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  /* Buttons */
  button {
    font-family: inherit;
  }

  /* Input Fields */
  input, textarea {
    font-family: inherit;
  }

  /* Scrollbar Styles */
  ::-webkit-scrollbar {
    width: thin;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.accentColor};
  }

  ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.background};
  }

  /* Selection */
  ::selection {
    background-color: ${({ theme }) => theme.accentColor};
    color: ${({ theme }) => theme.text};
  }

  /* Modal Overlay */
  .modal-overlay {
    background-color: rgba(0, 0, 0, 0.7);
  }

  /* Animations */
  @keyframes shake {
    0% { transform: translateX(0); }
    20% { transform: translateX(-8px); }
    40% { transform: translateX(8px); }
    60% { transform: translateX(-8px); }
    80% { transform: translateX(8px); }
    100% { transform: translateX(0); }
  }
`;

export default GlobalStyles;
